import React from 'react';
import { connect } from 'dva';

import './DraftInfo.pcss';
import { getLastSaveToDraftTime } from '../../../selectors/submit';

interface Props {
  savedTime: string;
}

function DraftInfo({ savedTime }: Props) {
  return (
    <div className="StepContentBlock DraftInfo">
      {savedTime
        ? `Изменения автоматически сохранены ${savedTime}`
        : 'Изменения сохраняются автоматически'}
    </div>
  );
}

export default connect((state) => {
  return {
    savedTime: getLastSaveToDraftTime(state),
  };
})(DraftInfo);
